import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment.mobile';
import { SafePipe } from '../../../components/pipes/safe.pipe';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-tour-callback',
  templateUrl: environment.mobile ? './tour-callback.component.mobile.html' : './tour-callback.component.html',
  styleUrls: ['./tour-callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SafePipe]
})
export class TourCallbackComponent {
  componentHTML: string = null;
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) hotelToursPageConfig: HotelToursPageConfig) {
    if (hotelToursPageConfig.callbackComponentHTML) {
      const countryNameTo = this.getCountryTo();
      this.componentHTML = hotelToursPageConfig.callbackComponentHTML.replace('{{countryNameTo}}', countryNameTo);
    }
    this.messages = hotelToursPageConfig.translates.tourCallback;
  }

  private getCountryTo(): string | null {
    let countryNameTo = null;
    if (environment.mobile) {
      if ((window as any).searchFormUtils) {
        const descriptions = (window as any).searchFormUtils?.getDescriptions?.();
        countryNameTo = descriptions?.toCountry ?? null;
      }
    } else {
      const countryId = (window as any).mainForm.country_id;
      const country = (window as any).mainForm.countries[countryId];
      countryNameTo = `${country.to} ${country.name2}`;
    }

    return countryNameTo;
  }
}
